export const api_key = "CNCPSMNCYffhTOap25";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-sdk-wrapper.sa.careplix.com");
export const sdkURL = (url = "") => new URL(url, "https://sdk.sa.careplix.com");

export const acceptList = new Set([
  "9051024866", // Arnab
  "8017029639", // Pathikrit
  "7003039310", // Ankit
  "9836374292", // Ankit 2
  "7980499854", // Subho da
  "9153055388", // Subrata
  "9830374972", // Mushkan
  "8013498116", // Somali
  "7980617669", // Shubhrayan
  "8340575988", // Kiran
  "9608734736", // Ujjawal
]);
